<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='$store.state.icons.dataBox.details.icon'
      :titleIconColor='$store.state.icons.dataBox.details.iconColor'
      :loading='isLoading'
      showEdit
      @edit='openEdit'
    >
      <wc-two-column-table :items='tableData'></wc-two-column-table>
      <v-card-text class='pt-0'>
        <span class='grey--text'><i>(Head count Formula: 2 X bigs + smalls)</i></span> 
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='$store.state.icons.dataBox.details.title'
      :icon='$store.state.icons.dataBox.details.icon'
      :iconColor='$store.state.icons.dataBox.details.iconColor'
      @cancel='cancelEdit'
      @save='saveEdit'
      :fullscreen='$vuetify.breakpoint.xs'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row>
          <v-col cols='12' sm='6'>
            <v-text-field
              v-model='estimateDetailCopy.zones'
              :rules='[rules.intOrEmpty]'
              label='Number of zones'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6'>
            <v-text-field
              v-model='estimateDetailCopy.head_count'
              :rules='[rules.intOrEmpty]'
              label='Number of heads'
              hint='(Head count Formula: 2 X bigs + smalls)'
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols='12'>
            <v-select
              label='Controller Type'
              :items='controllers'
              :loading='isLoadingControllers'
              dense
              v-model='estimateDetailCopy.controller'
              item-value='id'
              item-text='description'
            ></v-select>
          </v-col>
          <v-col cols='12'>
            <v-text-field
              v-model='estimateDetailCopy.controller_location'
              :rules='[sentenceRules.noPeriod, sentenceRules.startLowercase]'
              label='The controller is located...'
              hint='complete the sentence above (do not end with a period)'
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols='12'>
            <v-text-field
              v-model='estimateDetailCopy.shutoff_location'
              :rules='[sentenceRules.noPeriod, sentenceRules.startLowercase]'
              label='The shutoff is located...'
              :disabled='shutoffHint.disabled'
              :hint='shutoffHint.text'
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='6' class='mt-3'>
            <v-text-field
              label='Stack comes out on'
              dense
              v-model='estimateDetailCopy.mechanical_side'
            ></v-text-field>
          </v-col>
          <v-col cols='12' class='mt-n4'>
            <v-checkbox
              v-model='estimateDetailCopy.is_hose_bib'
              label='Hose Bib Supply? (no plumb)'
            ></v-checkbox>
            <v-checkbox
              v-model='estimateDetailCopy.charged_tap'
              label='Charged line for hose bib?'
              false-value='N'
              true-value='Y'
            ></v-checkbox>
            <v-checkbox
              v-model='estimateDetailCopy.charged_feature'
              label='Charged line for water feature?'
              false-value='N'
              true-value='Y'
            ></v-checkbox>
            <v-checkbox
              :hint="estimate.is_comm ? 'Commercial systems cannot have BM8' : ''"
              :persistent-hint='estimate.is_comm'
              :readonly='estimate.is_comm'
              :disabled='estimate.is_comm'
              v-model='estimateDetailCopy.can_have_bm8'
              label='Can this system have BM8/ES10  option?'>
            </v-checkbox>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
import inventoryAPI from '@/modules/assets/api/inventory'
export default {
  name: 'takeover-details',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoadingControllers: true,
    isFormValid: false,
    title: 'Takeover Details',
    showDialog: false,
    estimateDetailCopy: {},
    controllers: [],
    savedShutoffLocation: ''
  }),
  watch: {
    'estimateDetailCopy.is_hose_bib' () {
      if (this.estimateDetailCopy.is_hose_bib) {
        this.savedShutoffLocation = this.estimateDetailCopy.shutoff_location
        this.estimateDetailCopy.shutoff_location = '(n/a)'
      } else {
        this.estimateDetailCopy.shutoff_location = this.savedShutoffLocation
      }
    }
  },
  computed: {
    tableData () {
      return [
        { text: 'Controller Type', value: this.estimateDetail.controller ? this.estimateDetail.controller_obj.description : '' },
        { text: 'Controller Location', value: this.estimateDetail.controller_location },
        { text: 'Shutoff Location', value: this.estimateDetail.shutoff_location },
        { text: 'Hose Bib supply?', value: this.$options.filters.trueFalse(this.estimateDetail.is_hose_bib) },
        { text: 'Stack comes out on', value: this.estimateDetail.mechanical_side},
        { text: 'Charged Line for Hose bib?', value: this.estimateDetail.charged_tap === 'Y' ? 'Yes' : 'No' },
        { text: 'Charged Line for Water Feature?', value: this.estimateDetail.charged_feature === 'Y' ? 'Yes' : 'No' },
        { text: 'Can system have BM8/ES10 option?:', value: this.$options.filters.trueFalse(this.estimateDetail.can_have_bm8) },
        { text: 'Number of Zones', value: this.estimateDetail.zones },
        { text: 'Number of Heads', value: this.estimateDetail.head_count }
      ]
    },
    stackComesOut () {
      return this.$store.state.misc.globalOptions.estimateStackOptions
    },
    shutoffHint () {
      if (this.estimateDetailCopy.is_hose_bib)  {
        return { text: "Hose bib supply selected - this is not needed", disabled: true }
      } 
      return { text: "complete the sentence above (do not end with a period)", disabled: false }
    },
    sentenceRules() {
      return {
        noPeriod: (value) => {
          const pattern = /^[^.]+$|null|^\s*$/
          return pattern.test(value) || 'cannot contain or end with a period'
        },
        startLowercase: (value) => {
          const pattern = /^([a-z])|^(?![\s\S])/
          return pattern.test(value) || 'must start with lowercase letter'
        },
      }
    }
  },
  methods: {
    getSideDisplay (val) {
      if (this.stackComesOut.find(o => o.value === val) !== undefined) {
        return this.stackComesOut.find(o => o.value === val).text
      }
      return ''
    },
    async openEdit () {
      if (this.controllers.length === 0) {
        this.isLoadingControllers = true
        let tmp = await inventoryAPI.getInventoryForDivision(this.estimate.division)
        this.controllers = tmp.filter(i => i.is_controller === true)
        this.isLoadingControllers = false
      }
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.cancelEdit()
    },
  }
}
</script>
